import React from 'react';
var Mas2 = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "23", height: "22", viewBox: "0 0 23 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12.6193 9.9326H17.092V12.0989H12.6193V17H10.5346V12.0989H6.092V9.9326H10.5346V5.00006H12.6193V9.9326Z", fill: "var(--icon-primary-dark)" })));
};
Mas2.defaultProps = {
    className: '',
};
export default Mas2;
